import { render, staticRenderFns } from "./vendor-category.vue?vue&type=template&id=a6fd0ce2&"
import script from "./vendor-category.vue?vue&type=script&lang=js&"
export * from "./vendor-category.vue?vue&type=script&lang=js&"
import style0 from "./vendor-category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports